import { ComponentType } from 'react';
import { BinaryChoiceFilter } from './BinaryChoiceFilter';
import { BaseFilterProps } from './common';
import { NumberRangeFilter, NumberRangeFilterProps } from './NumberRangeFilter';
import { ScaledNumberRangeFilter, ScaledNumberRangeFilterProps } from './ScaledNumberRangeFilter';
import { StringSelectFilter } from './StringSelectFilter';
import { DateRangeFilter } from './DateRangeFilter';

export type FilterType = 'NumberRange' | 'ScaledNumberRange' | 'BinaryChoice' | 'StringSelect' | 'DateRange';

export type FilterProps = NumberRangeFilterProps | ScaledNumberRangeFilterProps;

export const FilterImplemetations: Record<FilterType, ComponentType<BaseFilterProps<any, any>>> = {
  NumberRange: NumberRangeFilter,
  ScaledNumberRange: ScaledNumberRangeFilter,
  DateRange: DateRangeFilter,
  StringSelect: StringSelectFilter,
  BinaryChoice: BinaryChoiceFilter,
};
